import { QueryType } from "../models";

export const getQueryType = (id?: number | string, queryType?: QueryType): QueryType => {
    if (queryType) {
        return queryType;
    }
    return id ? QueryType.Detail : QueryType.PagedList;
};
